export default __webpack_public_path__ + "static/media/9H.57bfd8e3.svg";